<template>
    <tr>
        <td class="id px-3">
            <span>{{ brandZone.zone.id }}</span>
        </td>
        <td class="ref px-3">
            <span>{{ brandZone.zone.refClient ? brandZone.zone.refClient : "-" }}</span>
        </td>
        <td class="name px-3">
            <span>{{ brandZone.zone.name }}</span>
        </td>
        <td class="type px-3">
            <span v-if="brandZone.active"> {{ brandZone.zoneRelationType.name }} </span>
            <span v-else>
                <i>({{ $trad.headerAdmin.zone.deleted }})</i>
            </span>
        </td>
        <td class="group px-3">
            <span v-if="brandZone.zoneGroupsRights"> {{ brandZone.zoneGroupsRights.name }} </span> <span v-else> - </span>
        </td>
        <td class="brands px-3">
            <span>
                <template v-for="(brand, key) in brandZone.brands">
                    <template v-if="key === 0">{{ brand.name }}</template>
                    <template v-else>{{ "&nbsp;• " + brand.name }}</template>
                </template>
            </span>
        </td>
        <td class="users text-center px-3">
            <span class="pointer" @click="emit('showUsers');"> {{ brandZone.zone.users.length }} </span>
        </td>
        <td class="edit-type text-center px-3" v-if="canManageZone()">
            <img class="position-relative" src="../../../assets/edit_type.svg" alt="edit-type" @click="emit('editTypeZone');" />
        </td>
        <td class="edit text-center px-3">
            <img
                class="position-relative"
                src="../../../assets/edit.svg"
                alt="edit"
                @click="$router.push({ path: '/zones/zone/' + brandZone.zone.id });"
            />
        </td>
        <!-- <td class="copy text-center px-3"> -->
        <!-- <img class="position-relative" src="../../../assets/copy.svg" alt="copy" @click="emit('copyFromZone')"> -->
        <!-- </td> -->
        <td class="delete shrink text-center px-3" v-if="canManageZone()">
            <img v-if="brandZone.active" class="position-relative" src="../../../assets/delete.svg" alt="delete" @click="emit('deleteZone');" />
        </td>
        <td class="history text-center px-3"><History :object="brandZone.zone" :object-type="OBJECT_TYPE.ZONES"></History></td>
    </tr>
</template>
<script>
import { mapGetters } from "vuex";
import TryLoad from "@/mixins/TryLoadMixin";
import History from "@/components/history/History";
import { OBJECT_TYPE } from "@/components/history/constants";

export default {
    mixins: [TryLoad],
    components: {
        History
    },
    props: {
        brandZone: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            OBJECT_TYPE
        };
    },
    computed: {
        ...mapGetters("brand", { zones: "getZones" })
    },
    methods: {
        emit(emit) {
            this.$emit(emit);
        },
        canManageZone() {
            return this.isSuperAdmin() || this.isClientAdmin();
        }
    },
    created() {}
};
</script>
<style scoped lang="scss">
tr {
    background-color: #f4f4f4;
    border-bottom: #fff 5px solid;
    td {
        padding: 10px;
        vertical-align: middle;
        overflow-wrap: break-word;
        color: black;
        font-size: 20px;
        line-height: 20px;
        transition: 0.3s ease-in-out;
        font-weight: 500;

        img {
            cursor: pointer;
        }

        &.id {
            width: 90px;
        }

        &.users,
        &.type,
        &.group {
            min-width: 120px;
            span,
            i {
                text-transform: capitalize;
            }
        }

        &.brands {
            width: 400px;
            span {
                line-height: 24px;
                display: block;
                text-transform: capitalize;
            }
        }

        &.edit,
        &.copy,
        &.edit-type,
        &.delete,
        &.history {
            width: 90px;
            @media (max-width: 1440px) {
                width: 70px;
                img {
                    width: 35px;
                }
            }
        }

        &.edit-type {
            width: 120px;
        }

        &.name,
        &.ref {
            min-width: 160px;
            span {
                font-family: Oswald, Sans-Serif;
                font-size: 20px;
                @media (max-width: 1440px) {
                    font-size: 18px;
                }
            }
        }

        &.id,
        &.type,
        &.group,
        &.users {
            text-align: center;
        }

        &.id,
        &.type,
        &.group,
        &.brands,
        &.users {
            span,
            i {
                font-family: "oswald-regular", Sans-Serif;
                font-size: 18px;
                @media (max-width: 1440px) {
                    font-size: 16px;
                }
            }
        }

        &.users {
            span {
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// ZoneDetailBanner.vue?1feb0078